<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard v-if="form">
        <CCardBody>
          <h3>
            Edit Technique
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CInput label="Name" type="text" placeholder="Name" v-model="form.technique_name"></CInput>
          <CInput label="Internal ID" type="text" placeholder="Internal ID" v-model="form.internal_id"></CInput>
          <CInput label="Prefix" type="text" placeholder="Prefix" maxlength="20" v-model="form.prefix"></CInput>
          <CInput label="Cost" type="double" placeholder="Cost" v-model="form.cost"></CInput>
          <CInput label="Min Quantity" type="number" placeholder="Min Quantity" v-model="form.min_quantity"></CInput>
          <CInput label="New Min Quantity" type="number" placeholder="New Min Quantity" v-model="form.new_min_quantity"></CInput>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Can Go Under New Min Quantity?</label>
            <div>
              <CButton size="sm" @click="form.can_go_under_new_min_quantity = 1" :color="form.can_go_under_new_min_quantity === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.can_go_under_new_min_quantity = 0" style="margin-left:5px;" :color="form.can_go_under_new_min_quantity === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Show Decoration Text Box Without Image?</label>
            <div>
              <CButton size="sm" @click="form.show_decoration_text = 1" :color="form.show_decoration_text === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.show_decoration_text = 0" style="margin-left:5px;" :color="form.show_decoration_text === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Three Dimensional?</label>
            <div>
              <CButton size="sm" @click="form.three_dimensional = 1" :color="form.three_dimensional === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.three_dimensional = 0" style="margin-left:5px;" :color="form.three_dimensional === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Default?</label>
            <div>
              <CButton size="sm" @click="form.default = 1" :color="form.default === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.default = 0" style="margin-left:5px;" :color="form.default === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <CInput v-if="form.can_go_under_new_min_quantity" label="Under New Min Quantity Upcharge" type="double" placeholder="Ex 75.00" v-model="form.under_min_quantity_upcharge"></CInput>
          
          <div style="width:100%;float:left;">
            <label>Type</label>
            <multiselect 
              v-model="form.type" 
              :options="['components', 'embroideries', 'heat_seals', 'vulcans']"
            />
          </div>
          <div style="width:100%;float:left;margin-top:15px;margin-bottom:15px;">
            <label>Tech Type</label>
            <multiselect 
              v-model="form.technique_type"
              :disabled="configureDisabled()"
              :options="techTypes"
            />
          </div>
          <CInput
            :lazy="false"
            type="number"
            label="Lead Time (in days)"
            :value.sync="form.lead_time"
            placeholder="Days Out to Order"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            type="text"
            label="Description"
            :value.sync="form.description"
            placeholder="Description"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;">
            <label>Programs</label>
            <multiselect
              v-if="programs" 
              v-model="form.programs" 
              :options="programs" 
              :multiple="true" 
              label="program_name" 
              track-by="program_id"
            />
          </div>
          <div style="width:100%;float:left;margin-top:15px;">
            <CButton color="primary" @click="update()">Save</CButton>
            <CButton color="bg-gray-100" class="ml-2" @click="goBack">Back</CButton>
          </div>
          <div style="width:100;float:left;height:50px;margin-top:15px;">
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.goBack = function () {
  this.$router.go(-1)
}

methods.configureDisabled = function () {
  if (this.form.type === 'embroideries' || this.form.type === 'heat_seals') {
    return true
  } else {
    return false
  }
}

methods.getStyle = function () {
  let self = this;
  axios.get(   this.$apiAdress + '/api/techniques/edit?token=' + localStorage.getItem("api_token") + '&id=' + self.$route.params.id)
  .then(function (response) {
      // self.name = response.data.menulist.name;
      self.form = response.data.res
      // self.styles = response.data.styles
      self.programs = response.data.programs
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

methods.update = function () {
  let self = this;
  console.log(this.form)
  axios.post(   this.$apiAdress + '/api/techniques/update' + '?token=' + localStorage.getItem("api_token"), self.form)
  .then(function (response) {
      self.message = 'Successfully updated this style.';
      self.showAlert();
  }).catch(function (error) {
      if(error.response.data.message == 'The given data was invalid.'){
        self.message = '';
        for (let key in error.response.data.errors) {
          if (error.response.data.errors.hasOwnProperty(key)) {
            self.message += error.response.data.errors[key][0] + '  ';
          }
        }
        self.showAlert();
      }
  });
}

methods.showAlert = function () {
  this.dismissCountDown = this.dismissSecs
}

export default {
  name: 'EditTechnique',
  data: () => {
    return {
        form: {
          technique_name: '',
          internal_id: '',
          prefix: '',
          type: '',
          technique_type: '',
          min_quantity: '',
          new_min_quantity: '',
          cost: '',
          lead_time: '',
          can_go_under_min_quantity: '',
          under_min_quantity_upcharge: '',
          three_dimensional: '',
          show_decoration_text: '',
          default: 0
        },
        message: '',
        dismissSecs: 3,
        dismissCountDown: 0,
        colors: null,
        decorations: null,
        styles: null,
        programs: null,
        techTypes: ['TAPE', 'H', 'PPE', 'PPMP', 'PPSM', 'PPHI', 'PPL']
    }
  },
  components: {
    Multiselect
  },
  methods: methods,
  watch: {
    'form.type': function (newVal, oldVal) {
      if (this.form.type === 'embroideries') {
        this.form.technique_type = 'TAPE'
      } else if (this.form.type === 'heat_seals') {
        this.form.technique_type = 'H'
      }
    }
  },
  mounted: function(){
    this.getStyle()
  }
}


</script>
